'use client';

import { usePathname } from "next/navigation";

export const legalNavLinks = [
    { label: "Terms and conditions", href: "/legal/terms" },
    { label: "Privacy policy", href: "/legal/privacy-policy" },
    { label: "Refund, Deferral & Payment Terms", href: "/legal/refund-policy" },
    { label: "Disclaimer", href: "/legal/disclaimer" },
    { label: "Copyright Notice", href: "/legal/copyright-notice" },
    { label: "Contact / Impressum", href: "/legal/contact-impressum" },
];

/** Active-page heading for the legal header. Client-only (needs the pathname). */
export function LegalPageTitle() {
    const pathname = usePathname();
    const activeLink = legalNavLinks.find(link => pathname?.startsWith(link.href));
    return <h3 className="ml-2">{activeLink ? activeLink.label : "Legal"}</h3>;
}

/** Sidebar nav with active-link highlighting. Client-only (needs the pathname). */
export function LegalNavLinks() {
    const pathname = usePathname();
    return (
        <nav role="navigation" className="legal_menu w-nav-menu">
            {legalNavLinks.map(link => (
                <a
                    key={link.href}
                    href={link.href}
                    aria-current={pathname?.startsWith(link.href) ? "page" : undefined}
                    className={`legal_link text-size-small${pathname?.startsWith(link.href) ? " w--current" : ""}`}
                >
                    {link.label}
                </a>
            ))}
        </nav>
    );
}
